import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { keHoachThucTapPhamViApi } from "../../../api/xet-thuc-tap/keHoachThucTapPhamViApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eKeHoachThucTapPhamViActionIds, IKeHoachThucTapPhamViActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eKeHoachThucTapPhamViSinhVienActionIds, IKeHoachThucTapPhamViSinhVienActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienActions";
import { keHoachThucTapPhamViSinhVienApi } from "../../../api/xet-thuc-tap/keHoachThucTapPhamViSinhVienApi";
import { IKeHoachThucTapPhamViSinhVien } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapPhamViSinhVien";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachThucTapPhamViSinhVienSelectRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienSelectRequest";
import { IKeHoachThucTapPhamViSinhVienInsertRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienInsertRequest";
import { eDotXetChungChiPhamViSinhVienActionIds } from "../../action-types/xet-chung-chi/IDotXetChungChiPhamViSinhVienActions";
import { IDotXetChungChiPhamViSinhVienActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiPhamViSinhVienActions";
import { IDotXetChungChiPhamViSinhVienSelectRequest } from "../../../model/request/xet-chung-chi/IDotXetChungChiPhamViSinhVienSelectRequest";
import { dotXetChungChiPhamViSinhVienApi } from "../../../api/xet-chung-chi/dotXetChungChiPhamViSinhVienApi";
import { IDotXetChungChiPhamViSinhVienInsertRequest } from "../../../model/request/xet-chung-chi/IDotXetChungChiPhamViSinhVienInsertRequest";

export function* dotXetChungChiPhamViSinhVienSaga(): any {
    yield takeLatest(eDotXetChungChiPhamViSinhVienActionIds.LOAD_BY_DOT_XET_START, loadByDotXetWorker);
    yield takeEvery(eDotXetChungChiPhamViSinhVienActionIds.INSERTS_START, addsWorker);
    yield takeEvery(eDotXetChungChiPhamViSinhVienActionIds.DELETES_START, deletesWorker);
}

    
function* loadByDotXetWorker(action: IDotXetChungChiPhamViSinhVienActionTypes) : any {
    const request = action.payload as IDotXetChungChiPhamViSinhVienSelectRequest;
    const response : IBaseResponse = yield dotXetChungChiPhamViSinhVienApi.SelectByDotXet(request);
    if (response.is_success) {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.LOAD_BY_DOT_XET_ERROR(response.message ?? "Lỗi khi tải phạm vi đợt xét chứng chỉ"));
    }
}

function* addsWorker(action: IDotXetChungChiPhamViSinhVienActionTypes) : any {
    const data = action.payload as IDotXetChungChiPhamViSinhVienInsertRequest;
    const response: IBaseResponse = yield dotXetChungChiPhamViSinhVienApi.Inserts(data);
    if (response.is_success) {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.INSERTS_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.INSERTS_ERROR(response.message ?? "Lỗi khi thêm phạm vi đợt xét chứng chỉ"));
    }
}

function* deletesWorker(action: IDotXetChungChiPhamViSinhVienActionTypes) : any {
    const ids = action.payload as IIdsRequest;
    const response: IBaseResponse = yield dotXetChungChiPhamViSinhVienApi.Deletes(ids);
    if (response.is_success) {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.DELETES_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetChungChi.dotXetChungChiPhamViSinhVien.DELETES_ERROR(response.message ?? "Lỗi khi xóa phạm vi đợt xét chứng chỉ"));
    }
}